import { defineMessages, IntlShape } from 'react-intl';

const messages = defineMessages({
  decision_aid: {
    id: 'Decision aid',
    defaultMessage: 'Decision aid',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  labelIcon: {
    id: 'FontAwesome Icon',
    defaultMessage: 'FontAwesome Icon',
  },
  descrIcon: {
    id: 'Full list of available icons (copy & paste name): https://react.semantic-ui.com/elements/icon',
    defaultMessage:
      'Full list of available icons (copy & paste name): https://react.semantic-ui.com/elements/icon',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  labelCTAText: {
    id: 'Call-to-Action',
    defaultMessage: 'Call-to-Action',
  },
});

export const DecisionAidSchema = (intl: IntlShape) => {
  return {
    title: intl.formatMessage(messages.decision_aid),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'icon', 'description', 'cta_text', 'decision_tree'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title),
      },
      icon: {
        title: intl.formatMessage(messages.labelIcon),
        description: intl.formatMessage(messages.descrIcon),
      },
      description: {
        title: intl.formatMessage(messages.description),
        widget: 'richtext',
      },
      cta_text: {
        title: intl.formatMessage(messages.labelCTAText),
      },
      decision_tree: {
        title: 'Decision tree',
        description: 'JSON definition of the decision tree',
        widget: 'textarea',
      },
    },
    required: [],
  };
};

export default DecisionAidSchema;
